import React, {useEffect, useState} from "react";
import './../Purchase.scss';
import './../PurchasePage.scss';
import Strings from "../../../../config/Strings";
import {Spinner} from "react-bootstrap";
import {CreateResource, GetUnauthorizedResources} from "../../../../api/SpineClient";
import {getAccount, loginUser} from "../../../../authentication/Oauth2Service";
import {useHistory} from "react-router";
import {authCheck} from "../../../../util/authCheck";
import GlobalConstants from "../../../../config/GlobalConstants";
import {InfoModal} from "../../../../global/ConfirmationModal";
import PurchaseStatus from "../PurchaseStatus";
import googleTagManagerWrapper from "../../../../api/GoogleTagManagerWrapper";
import gtmw from "../../../../api/GoogleTagManagerWrapper";
import {Link, useLocation} from "react-router-dom";

export default function SubscriptionPurchaseAuthentication({ setToken, setEmail }) {

    const ERROR_CODE_DUPLICATE_EMAIL = "400-03";
    const ERROR_CODE_PASSWORT_TOO_SHORT = "400-01";

    const [purchaseData] = useState(() => JSON.parse(sessionStorage.getItem('ls.purchase')));
    const [form, setForm] = useState({
        email: "",
        password: "",
        passwordConfirmation: "",
        terms: false,
        newsletter: false,
        registerDeviceId: "customer-ui-service"
    });
    const [formType, setFormType] = useState((purchaseData && (purchaseData.selectedColor || purchaseData.promotion)
                                                    ? "REGISTER" : "LOGIN"));
    const [formError, setFormError] = useState({
        email: null,
        password: null,
        passwordConfirmation: null,
        terms: null,
        newsletter: null
    });
    const [formIsValid, setFormIsValid] = useState(form.code != null && form.password != null);
    const [loading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [planVariant, setPlanVariant] = useState(null);

    const history = useHistory();

    document.title = Strings.PURCHASE_SUBSCRIPTION_BROWSER_TAB;
    const location = useLocation();

    useEffect(() => {

        if (!purchaseData) {
            history.push("/" + GlobalConstants.APP_PATH + "purchase" + location.search);
            return;
        }

        const updatedPurchase = { ...purchaseData };

        const loadPlanVariant = async (planVariantId) => {
            setLoading(true);
            let p = await GetUnauthorizedResources(
                'api/premiumAccessFeatures/search/by-planVariantId?planVariantId=' + planVariantId,
                null,
                'application/json',
                GlobalConstants.SPINE_HOST
            );
            setLoading(false);
            if (p.error || p.result == null) {
                history.push("/" + GlobalConstants.APP_PATH + "purchase/error?code=4");
                return;
            }
            return p.result;
        };

        loadPlanVariant(updatedPurchase.planVariantId).then(r => {
            setPlanVariant(r);
            gtmw.beginCheckoutEvent(updatedPurchase);
        });

        if (authCheck()) {
            updatedPurchase.maxStep = 2;
            sessionStorage.setItem('ls.purchase', JSON.stringify(updatedPurchase));
            history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/payment" + location.search);
        } else {
            updatedPurchase.maxStep = 1;
            sessionStorage.setItem('ls.purchase', JSON.stringify(updatedPurchase));
        }


    }, [location, history, purchaseData]);

    //Submitting
    const authenticate = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const loadAccountId = async (token) => {
            const account = (await getAccount(token));
            if(account) {
                sessionStorage.setItem('ls.accountId', JSON.stringify(account.id));
            }
        }

        setLoading(true);

        let newToken = await loginUser(form);

        if (newToken) {
            googleTagManagerWrapper.login();
            //Token is available -> Set the expiration date/time
            let expiredAt = new Date();
            expiredAt.setSeconds(expiredAt.getSeconds() + newToken.expires_in);
            newToken.expires_at = expiredAt.getTime();

            await loadAccountId(newToken);
            setToken(newToken);
            setEmail(form.email);

            sessionStorage.setItem("email", JSON.stringify({email: form.email}));
            purchaseData.maxStep = 2;
            sessionStorage.setItem('ls.purchase', JSON.stringify(purchaseData));
            history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/payment");
        }
        else {
            setFormError({
                ...formError,
                email: Strings.TICKET_REDEMPTION_AUTHENTICATE_ERROR,
                password: Strings.TICKET_REDEMPTION_AUTHENTICATE_ERROR
            });
        }

        setLoading(false);
    }

    const register = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);

        let response = await CreateResource('api/register', form);
        if (!response.error) {

            googleTagManagerWrapper.registration();

            let newToken = await loginUser(form);

            let expiredAt = new Date();
            expiredAt.setSeconds(expiredAt.getSeconds() + newToken.expires_in);
            newToken.expires_at = expiredAt.getTime();
            setToken(newToken);
            setEmail(form.email);
            sessionStorage.setItem("email", JSON.stringify({email: form.email}));
            purchaseData.maxStep = 2;
            sessionStorage.setItem('ls.purchase', JSON.stringify(purchaseData));
            history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/payment");
        } else {
            if (response.message.indexOf(ERROR_CODE_DUPLICATE_EMAIL) > -1) {
                setFormError({...formError, email: Strings.TICKET_REDEMPTION_REGISTER_EMAIL_ERROR});
            } else if (response.message.indexOf(ERROR_CODE_PASSWORT_TOO_SHORT) > -1) {
                setFormError({...formError, password: Strings.TICKET_REDEMPTION_REGISTER_PASSWORD_TOO_SHORT});
            } else {
                setErrorMessage(Strings.TICKET_REDEMPTION_REDEMPTION_UNKNOWN_ERROR);
                setShowError(true);
            }
        }

        setLoading(false);
    }


    const updateForm = (field, value, formIsValid) => {
        setForm({
            ...form,
            [field]: value
        });
        setFormError({
            ...formError,
            [field]: null
        });
        setFormIsValid(formIsValid);
    }

    const validateForm = () => {
        //REGISTER
        if (formType === "REGISTER") {
            if (form.email.indexOf("@") < 0) {
                setFormError({...formError, email: Strings.TICKET_REDEMPTION_REGISTER_INVALID_EMAIL});
                return false;
            } else if (form.password.length < 8) {
                setFormError({...formError, password: Strings.TICKET_REDEMPTION_REGISTER_PASSWORD_TOO_SHORT});
                return false;
            } else if (form.password !== form.passwordConfirmation) {
                setFormError({...formError, passwordConfirmation: Strings.TICKET_REDEMPTION_REGISTER_PASSWORD_DONT_MATCH});
                return false;
            }
        } else if (formType === "LOGIN") {
            if (form.email.indexOf("@") < 0) {
                setFormError({...formError, email: Strings.TICKET_REDEMPTION_REGISTER_INVALID_EMAIL});
                return false;
            }
        }
        return true;
    }

    const onChangeStep = (step) => {
        switch (step) {
            case 0:
                history.push("/" + GlobalConstants.APP_PATH + "bundles/colors?planVariantId=" + purchaseData.planVariantId + "&componentId=" + purchaseData.componentId + (purchaseData.discountId ? "&discountId=" + purchaseData.discountId : ''));
                return;
            case 1:
                //Active step -> Do nothing
                return;
            case 2:
                if (purchaseData.maxStep > 2) {
                    history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/payment");
                }
                return;
            case 3:
                if (purchaseData.maxStep > 2) {
                    history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/confirmation");
                }
                return;
            case 4:
                if (purchaseData.maxStep > 3) {
                    history.push("/" + GlobalConstants.APP_PATH + "purchase/subscription/confirmation");
                }
                return;
            default:
                return;
        }
    }

    const bundled = !!purchaseData?.selectedColor;

    //the labels are shared with the ticket redemption and end with a colon, which the labels of the purchase pages don't have
    const renderField = (field, id, label, inputProps, labelAddition = null) => (
        <div className="purchase-page-field">
            <label htmlFor={id} className="purchase-page-label">
                {label.replace(/:\s*$/, "")}
                {labelAddition}
            </label>
            <input id={id}
                   className={"purchase-page-input" + (formError[field] != null ? " invalid" : "")}
                   value={form[field]}
                   aria-invalid={formError[field] != null}
                   {...inputProps}/>
            {formError[field] != null &&
                <div className="purchase-page-message error">{formError[field]}</div>
            }
        </div>
    );

    if (formType === "LOGIN") {
        return (
            <div className="purchase-container">
                <PurchaseStatus step={1} maxStep={purchaseData != null ? purchaseData.maxStep : 1} bundled={bundled}
                                onChangeStep={(step) => onChangeStep(step)}
                />
                <form className="purchase-page" noValidate onSubmit={(e) => authenticate(e)}>
                    <h1 className="purchase-page-title">{Strings.PURCHASE_LOGIN_TITLE}</h1>
                    {!bundled &&
                        <div className="purchase-page-info"
                             dangerouslySetInnerHTML={{__html: Strings.PURCHASE_SUBSCRIPTION_AUTHENTICATE_PRODUCT_NAME.replace(
                                 "{0}",
                                 planVariant?.checkoutProductName ?? ""
                             )}}
                        />
                    }
                    {bundled &&
                        <div className="purchase-page-info" dangerouslySetInnerHTML={{__html: Strings.PURCHASE_BUNDLE_AUTHENTICATE_INFO}}/>
                    }

                    <div className="purchase-page-box with-fields">
                        {renderField("email", "email", Strings.TICKET_REDEMPTION_AUTHENTICATE_EMAIL, {
                            type: "email",
                            autoComplete: "email",
                            placeholder: Strings.TICKET_REDEMPTION_AUTHENTICATE_EMAIL_HINT,
                            onChange: e => updateForm('email', e.target.value, e.target.value.indexOf("@") > -1 && form.password.length >= 8),
                        })}
                        {renderField("password", "password", Strings.TICKET_REDEMPTION_AUTHENTICATE_PASSWORD, {
                                type: "password",
                                autoComplete: "current-password",
                                placeholder: Strings.TICKET_REDEMPTION_AUTHENTICATE_PASSWORD_HINT,
                                onChange: e => updateForm('password', e.target.value, e.target.value.length >= 8 && form.email.indexOf("@") > -1),
                            },
                            <Link to={"/" + GlobalConstants.APP_PATH + "forgot-password"}>{Strings.FORGOT_PASSWORD_TITLE}</Link>
                        )}
                    </div>

                    <button type="submit" className="purchase-page-button" disabled={loading}>
                        {loading ? <Spinner animation="border" size="sm"/> : Strings.TICKET_REDEMPTION_AUTHENTICATE_BUTTON}
                    </button>

                    <div className="purchase-page-switch">
                        <p>{Strings.TICKET_REDEMPTION_SWITCH_TO_REGISTER_INFO}</p>
                        <button type="button" className="purchase-page-button secondary" onClick={() => setFormType("REGISTER")}>
                            {Strings.TICKET_REDEMPTION_SWITCH_TO_REGISTER_BUTTON}
                        </button>
                    </div>
                </form>
            </div>
        )
    }

    return (
        <div className="purchase-container">
            {!purchaseData?.promotion &&
                <PurchaseStatus step={1} maxStep={purchaseData != null ? purchaseData.maxStep : 1} bundled={bundled}
                                onChangeStep={(step) => onChangeStep(step)}
                />
            }

            {purchaseData?.promotion &&
                <>
                    <div className="promotion-header-overlay">
                        <div>
                            <img src={purchaseData.promotion.headerImg}
                                 alt={"header"}/>
                        </div>
                    </div>

                    {purchaseData.promotion.descriptionText &&
                        <div className="promotion-description-text" dangerouslySetInnerHTML={{__html: purchaseData.promotion.descriptionText}}/>
                    }
                </>
            }

            <form className="purchase-page" noValidate onSubmit={(e) => register(e)}>
                <h1 className="purchase-page-title">{Strings.PURCHASE_REGISTER_TITLE}</h1>
                {!bundled && !purchaseData?.promotion &&
                    <div className="purchase-page-info" dangerouslySetInnerHTML={{__html: Strings.PURCHASE_SUBSCRIPTION_REGISTER_INFO.replace("{0}", planVariant?.checkoutDescription)}}/>
                }
                {bundled &&
                    <div className="purchase-page-info">
                        <span dangerouslySetInnerHTML={{__html: Strings.PURCHASE_BUNDLE_REGISTER_INFO}}/>
                        <br/>
                        {Strings.PURCHASE_BUNDLE_LOGIN_HINT + " "}
                        <button type="button" className="purchase-page-link" onClick={() => setFormType("LOGIN")}>
                            {Strings.PURCHASE_BUNDLE_LOGIN_LINK}
                        </button>
                    </div>
                }

                <div className="purchase-page-box with-fields">
                    {renderField("email", "emailRegistration", Strings.TICKET_REDEMPTION_REGISTER_EMAIL, {
                        type: "email",
                        autoComplete: "email",
                        placeholder: Strings.TICKET_REDEMPTION_REGISTER_EMAIL_HINT,
                        onChange: e => updateForm('email', e.target.value,
                            e.target.value.indexOf("@") > -1 && form.password.length >= 8 && form.password === form.passwordConfirmation),
                    })}
                    {renderField("password", "passwordRegistration", Strings.TICKET_REDEMPTION_REGISTER_PASSWORD, {
                        type: "password",
                        autoComplete: "new-password",
                        placeholder: Strings.TICKET_REDEMPTION_REGISTER_PASSWORD_HINT,
                        onChange: e => updateForm('password', e.target.value,
                            e.target.value.length >= 8 && form.email.indexOf("@") > -1 && form.password === form.passwordConfirmation && form.terms),
                    })}
                    {renderField("passwordConfirmation", "passwordRepeatRegistration", Strings.TICKET_REDEMPTION_REGISTER_PASSWORD_CONFIRMATION, {
                        type: "password",
                        autoComplete: "new-password",
                        placeholder: Strings.TICKET_REDEMPTION_REGISTER_PASSWORD_CONFIRMATION_HINT,
                        onChange: e => updateForm('passwordConfirmation', e.target.value,
                            form.password === e.target.value && form.email.indexOf("@") > -1 && form.password.length >= 8 && form.terms),
                    })}

                    <label className="purchase-page-checkbox">
                        <input name="newsletter" id="newsletter" type="checkbox" checked={form.newsletter}
                               onChange={(e) => updateForm('newsletter', e.target.checked, formIsValid)}/>
                        <span dangerouslySetInnerHTML={{__html: Strings.PURCHASE_REGISTER_NEWSLETTER}}/>
                    </label>
                    <label className="purchase-page-checkbox">
                        <input name="terms" id="terms" type="checkbox" checked={form.terms} onChange={(e) => {
                            updateForm('terms', e.target.checked,
                                e.target.checked &&
                                form.password === form.passwordConfirmation && form.email.indexOf("@") > -1 &&
                                form.password.length >= 8
                            );
                        }}/>
                        <span dangerouslySetInnerHTML={{__html: Strings.PURCHASE_REGISTER_TERMS}}/>
                    </label>
                </div>

                <button type="submit" className="purchase-page-button" disabled={loading || !formIsValid}>
                    {loading ? <Spinner animation="border" size="sm"/> : Strings.TICKET_REDEMPTION_REGISTER_BUTTON}
                </button>

                <div className="purchase-page-switch">
                    <p>{Strings.TICKET_REDEMPTION_SWITCH_TO_LOGIN_INFO}</p>
                    <button type="button" className="purchase-page-button secondary" onClick={() => setFormType("LOGIN")}>
                        {Strings.TICKET_REDEMPTION_SWITCH_TO_LOGIN_BUTTON}
                    </button>
                </div>

                {purchaseData?.promotion?.checkoutText &&
                    <p className="purchase-page-note" dangerouslySetInnerHTML={{__html: purchaseData.promotion.checkoutText}}/>
                }
            </form>

            <InfoModal
                title={Strings.REGISTER_UNKNOWN_ERROR_TITLE}
                text={errorMessage}
                show={showError}
                onHide={() => setShowError(false)}/>
        </div>
    )
}
